module.exports = __webpack_public_path__ + "static/island-b1dfc7567a59a837ee0184164f132013.jpg";